import { Link, usePage } from "@inertiajs/react";
import HeaderUser from "./HeaderUser";
import ImpersonationBanner from "../ImpersonationBanner";

export default function Header() {
  const { url, component, props } = usePage();
  const isBrainstormLanding = component === "Brainstorm" && !(props as any).thread_id;
  const isHomepage = url === "/" || url.startsWith("/?") || isBrainstormLanding;

  return (
    <>
      <ImpersonationBanner />
      <header
        className={`bg-background py-2 sticky top-0 z-[9998] relative ${isHomepage ? "" : "border-b border-base-200"}`}
      >
        <div className="flex justify-between items-center px-4">
          <Link href="/">
            <img src="/images/launch10-logo.svg" alt="Launch10" className="h-6" />
          </Link>
          <HeaderUser headerClassName="absolute right-0 top-full" />
        </div>
      </header>
    </>
  );
}
